<template>
    <div>
        <img
            class="note-image"
            @click="handleMakeNoteClick"
            src="/static/images/icons/notes-icon.png"
            alt="note"
        >

        <validation-observer
            ref="note"
            v-slot="{ invalid }"
        >
            <modal
                :id="noteModalId"            
                title="Make Notes"
                scrollable
                ok-title="Save"
                :ok-disabled="invalid"
                @ok="handleMakeNote"
                @cancel="handleCancelNote"
                @hidden="handleCancelNote"
                @shown="onModalShown"
            >
                <b-row>
                    <b-col>
                        <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <form-textarea
                                rows="5"
                                label="Note:"
                                v-model="noteText"
                                :error="errors[0]"
                            ></form-textarea>
                        </validation-provider>
                    </b-col>
                </b-row>
            </modal>
        </validation-observer>
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import API from '../../../../api';
import {
    DASHBOARD_INQUIRY_NOTE_ENDPOINT,
} from '../../../../endpoints';
import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
import Modal from '../../../generic/modal/modal.vue';
import { formatResponseError } from '../../../../utils/api';

export default {
    components: {
        FormTextarea,
        Modal,
    },
    data() {
        return {
            loading: false,
            noteModalId: '',
            noteText: '',
        };
    },
    created() {
        this.inquiry = this.params.data;
        this.noteModalId = `dashboard--widgets--inquiries-table-card--notes-cell-renderer--modal-${this.inquiry.id}`;
        this.noteText = '';
    },
    methods: {
        handleMakeNoteClick() {
            this.$bvModal.show(this.noteModalId);
        },
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        async handleMakeNote() {
            try {
                await API.post(
                    DASHBOARD_INQUIRY_NOTE_ENDPOINT(this.inquiry.id),
                    {
                        text: this.noteText,
                    }
                );
                this.params.refresh();
                this.successToast({text: `Note successfully added.`});
            } catch (error) {
                const { generic, fields } = formatResponseError(error);
                
                if (generic) {
                    this.errorToast({text: generic});
                }
                if (!generic && !isEmpty(fields)) {
                    this.$refs.note.setErrors(fields);
                }
            } finally {
                this.noteText = '';
            }
        },
        handleCancelNote() {
            this.noteText = '';
        },
    }
}
</script>
<style lang="scss" scoped>
    .note-image {
        cursor: pointer;
        height: 25px;
    }
</style>